import { render, staticRenderFns } from "./cancelAccountComponent.vue?vue&type=template&id=1bf9344a&scoped=true&"
import script from "./cancelAccountComponent.vue?vue&type=script&lang=js&"
export * from "./cancelAccountComponent.vue?vue&type=script&lang=js&"
import style0 from "./cancelAccountComponent.vue?vue&type=style&index=0&id=1bf9344a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf9344a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VForm,VIcon,VTextField})
